module.exports = __webpack_public_path__ + "img/EDA52.1c2d1be1.png";